import { get, isNull, isUndefined } from "lodash";
import React, { createElement } from "react";
import areaStyle from "./areaCell.module.scss";
import moneyStyle from "./moneyCell.module.scss";
import { formatPointLabel } from "components/widgets/chart/base/utils";
import { ChartSelectValueFormatKind } from "store/current-dashboard/types";
export const CustomCell = ({ value, isHeaderCell, colDef, currency, unit, className }) => {
    const format = get(colDef, "format");
    let formatOptions = {};
    if (format === ChartSelectValueFormatKind.percent) {
        formatOptions = { maximumFractionDigits: 2, minimumFractionDigits: 2 };
    }
    else if (format === ChartSelectValueFormatKind.amount) {
        formatOptions = { compactDisplay: "short",
            maximumFractionDigits: 2,
            minimumFractionDigits: 1,
            notation: "compact" };
    }
    else if (format === ChartSelectValueFormatKind.area) {
        formatOptions = { compactDisplay: "short",
            maximumFractionDigits: 2,
            minimumFractionDigits: 1,
            notation: "compact" };
    }
    let valueShown = formatPointLabel(value?.amount ?? value, format ?? ChartSelectValueFormatKind.string, "", formatOptions);
    if (isNull(valueShown) || isUndefined(valueShown)) {
        valueShown = "-";
    }
    else if (format === ChartSelectValueFormatKind.amount) {
        valueShown = [valueShown, " ", React.createElement("span", { key: 1, className: moneyStyle.currency }, value?.currency ?? currency)];
    }
    else if (format === ChartSelectValueFormatKind.area) {
        valueShown = [valueShown, " ", React.createElement("span", { key: 1, className: areaStyle.unit }, unit)];
    }
    return createElement(isHeaderCell ? "th" : "td", { className }, valueShown);
};
